import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FareProduct, PaymentMethod } from '../../services/types/apitypes';
import PaymentItem from '../payments/PaymentItem';
import { IonButton } from '@ionic/react';
import { currencyFormat } from '../../utils/currency'
import {AdditionalPaymentMethod} from "../payments/PaymentsList";

type CardPassesPayTopProps = {
  paymentMethod: PaymentMethod | AdditionalPaymentMethod;
  product: FareProduct;
  chosePayments: () => void;
  finish: (pa: PaymentMethod, pr: FareProduct) => void;
  collectJs: any;
};

export default function CardPassesPayBottom({
  paymentMethod,
  chosePayments,
  finish,
  product,
  collectJs,
}: CardPassesPayTopProps) {
  const [t] = useTranslation('global');

  useLayoutEffect(() => {
    if (collectJs) {
      collectJs.configure();
    }
  }, [collectJs]);

  return (
    <>
      <h1 className="h1 pb-1">{t('cardpasses.paymentmethod')}</h1>
      {typeof paymentMethod === "string" ?
          <PaymentItem click={chosePayments} otherPaymentType={paymentMethod} />
      :
      <PaymentItem payment={paymentMethod} click={chosePayments} />}
      <h1 className="h1 h1plus ">
        {t('cardpasses.total')} {currencyFormat(product.price / 100)}
      </h1>
      <div className="pt-5 ion-text-center">
          {(typeof paymentMethod === "string") ? <>
            <div className="platform-button"></div>
          </> :
        <IonButton
          className="btn-default btn-wide-80"
          onClick={() => finish(paymentMethod, product)}
        >
          {t('cardpasses.paynow')}
        </IonButton>}
      </div>
    </>
  );
}
